export function getCurrentLanguage() {
  const { location } = window;
  const parts = location.pathname.split("/");
  const lang = parts[1];

  return lang;
}